import type { MaybeRef } from 'vue'
import type { Discount, Maybe } from '@/types'
import type { CartDiscounts, CartSum } from '@/types/customer/products'

import { computed, unref } from 'vue'

export const useDiscountsAndSum = (
  discounts: MaybeRef<Maybe<CartDiscounts>>,
  sum: MaybeRef<Maybe<CartSum>>
) => {
  const couponEntity = computed<Maybe<Discount>>(
    () => unref(discounts)?.coupon?.[0] ?? null
  )
  const giftcardEntity = computed<Maybe<Discount>>(
    () => unref(discounts)?.giftcard?.[0] ?? null
  )

  const personalEntity = computed<Maybe<Discount>>(
    () => unref(discounts)?.personal?.[0] ?? null
  )

  const totalSum = computed(() => unref(sum)?.total ?? 0)
  const discountedSum = computed(() => unref(sum)?.discounted ?? 0)

  const personalDiscountSum = computed(
    () => unref(sum)?.discounts?.personal ?? 0
  )
  const couponDiscountSum = computed(() => unref(sum)?.discounts?.coupon ?? 0)

  const finalDiscountSum = computed(() => unref(sum)?.discount ?? 0)

  const finalDiscountEntity = computed<Maybe<Discount>>(() => {
    if (finalDiscountSum.value === personalDiscountSum.value) {
      return unref(discounts)?.personal?.[0] ?? null
    }

    if (finalDiscountSum.value === couponDiscountSum.value) {
      return couponEntity.value
    }

    return null
  })

  return {
    couponEntity,
    giftcardEntity,
    personalEntity,

    totalSum,
    discountedSum,

    personalDiscountSum,
    couponDiscountSum,

    finalDiscountSum,

    finalDiscountEntity,
  }
}
